import { render, staticRenderFns } from "./MakeCall.vue?vue&type=template&id=7fdea850&scoped=true&"
import script from "./MakeCall.vue?vue&type=script&lang=js&"
export * from "./MakeCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdea850",
  null
  
)

export default component.exports